import { css } from '@emotion/css'
import colors from '@styles/colors';
import { mobileOnly, tabletPortraitUp, tabletLandscapeUp, desktopUp } from '@styles/breakpoints';

export default {
    pageContainer: css({
        padding: '0 !important',
        '.custom-column': {
            [mobileOnly]: {
                paddingLeft: 0,
                paddingRight: 0,
            },
            '.summary-table': {
                marginBottom: 16,

                [mobileOnly]: {
                    marginTop: -25,
                    marginLeft: -25,
                    marginRight: -25,
                },
            },
        },
        '.managing': {
            background: '#EBEEF6',
            borderRadius: 10,
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: 14,
            margin: 'auto auto 24px auto',
            color: colors.BLUE,
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: 503,
            padding: '20px 30px',
            lineHeight: '1.2',

            img: {
                marginRight: 10
            }
        },
        '.tm-text': {
            fontSize: 15,
            lineHeight: '145%',
            letterSpacing: '0.02em',
            textAlign: 'center',
            color: 'rgba(21, 32, 107, 0.5)',
            margin: '30px 45px 10px 45px',

            '&.tablet': {
                display: 'block',
                color: '#8186AE',
            },
            '&.desktop': {
                display: 'none',
            },

            [tabletLandscapeUp]: {
                marginTop: 20,
                marginBottom: 40,
                marginLeft: -20,
                marginRight: -20,

                '&.tablet': {
                    display: 'none'
                },
                '&.desktop': {
                    display: 'block',
                }
            },
        },
    }),

    container: css({
        maxWidth: 1280,
        margin: '0 auto',

        label: {
            paddingBottom: '7px !important',
        },
    }),

    emptyCart: css({
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 0 40px 0',

        div: {
            fontStyle: 'normal',
            fontWeight: 'bold',
            fontSize: 16,
            textAlign: 'center',
            letterSpacing: '0.02em',
            marginBottom: 30,
        },

        '.add-more': {
            width: '100%',
            color: '#3856A7 !important',
            borderRadius: 4,
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px !important',
            borderStyle: 'dotted !important',
            borderColor: '#ebeef6 !important',
            textTransform: 'capitalize',
            letterSpacing: 'inherit',
            fontSize: '16px !important',
            fontWeight: 400,

            '&:hover': {
                background: 'white !important',
                color: '#3856A7 !important',
            }
        },

        img: {
            marginLeft: 8
        }
    }),

    cartBoxes: css({
        marginLeft: 50,
        marginRight: 50,
        marginTop: 48,
        marginBottom: 30,
        minHeight: '85%',
        display: 'flex',
        flexDirection: 'column',

        '.cart-total-mobile': {
            display: 'block',

            [tabletLandscapeUp]: {
                display: 'none'
            }
        },
        '.cart-total-desktop': {
            display: 'none',

            [tabletLandscapeUp]: {
                display: 'block'
            }
        },
        '.cart-total-mobile, .cart-total-desktop': {

            '.total': {
                marginLeft: 8,
                fontStyle: 'normal',
                fontWeight: 'bold',
                fontSize: 15,
                lineHeight: '135%',
                color: colors.GREEN_BRIGHT
            },
            '.subtotal': {
                fontStyle: 'normal',
                fontWeight: 'bold',
                fontSize: 15,
                lineHeight: '135%',
                textDecorationLine: 'line-through',
                color: colors.BLUE
            },
        },

        '.heading': {
            display: 'flex',
            flexWrap: 'nowrap',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: 'row',
            marginBottom: 17,

            h1: {
                fontStyle: 'normal',
                fontWeight: 800,
                fontSize: 28,
                letterSpacing: '0.02em',
                color: colors.NAVY,
                display: 'block',
                [desktopUp]: {
                    display: 'none',
                }
            },

            '.cart-menu': {
                padding: 0,
                listStyleType: 'none',
                alignItems: 'center',
                display: 'none',
                gap: 25,
                [desktopUp]: {
                    display: 'flex',
                    gap: 25,
                },
                '.cart-menu-link': {
                    opacity: 0.5,
                    fontWeight: 'bold',
                    fontSize: 14,
                    lineHeight: '135%',
                    letterSpacing: '0.01em',
                    '&.active': {
                        opacity: 1,
                    }
                }
            },

            '.subscribe-all': {
                display: 'flex',
                alignItems: 'center',

                '.label': {
                    fontStyle: 'normal',
                    fontWeight: 'bold',
                    fontSize: 14,
                    letterSpacing: '0.01em',
                    marginLeft: 14,
                    alignSelf: 'center',
                },

                '.container-checkbox': {
                    display: 'flex',
                },

                '.tooltip-img': {
                    marginLeft: 17,
                    cursor: 'pointer',
                }
            },
        },

        '.image': {
            marginRight: 38,

            img: {
                height: 'auto',
                display: 'block',
                borderRadius: 10,
                maxWidth: '140px !important',
            },

            [mobileOnly]: {
                marginRight: 20,
                alignSelf: 'baseline',
                maxWidth: '100% !important',
                width: '70%',

                img: {
                    maxWidth: '100% !important',
                }
            },
        },

        '.box': {
            display: 'flex',
            justifyContent: 'flex-start',
            flexWrap: 'nowrap',
            flexDirection: 'row',
            alignItems: 'flex-start',
            width: '100%',
            // borderBottom: `1px solid ${colors.BLUE_EXTRA_LIGHT}`,
            padding: '30px 0',

            [mobileOnly]: {
                marginTop: 23,
                paddingBottom: 23,
            },

            '&:last-child': {
                borderBottom: 'none',
            },
            '.remove-edit': {
                marginBottom: 'auto',
            },
            '.wrapper': {
                width: '100%',

                [mobileOnly]: {
                    maxWidth: 240,

                    '.ing-tooltip': {
                        marginLeft: '15vw',
                    },
                },

                '.info, .action, .remove-edit': {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    width: '100%',
                    [tabletLandscapeUp]: {
                        justifyContent: 'space-between',
                        alignContent: 'center',
                        alignItems: 'flex-start',
                    },

                    '.added': {
                        margin: '0 !important',
                    }
                },

                '.action, .remove-edit': {
                    flexDirection: 'column',
                    [tabletLandscapeUp]: {
                        flexDirection: 'row',
                    }
                },

                '.action': {
                    '.limited-time': {
                        padding: '4px 10px',
                        background: colors.BLUE_EXTRA_LIGHT,
                        borderRadius: 2,
                        color: colors.NAVY,
                        fontWeight: 500,
                        fontSize: 12,
                        lineHeight: '15px',
                        width: 'fit-content',
                        marginRight: 15
                    }
                },

                '.info': {
                    marginBottom: 8,

                    h3: {
                        fontWeight: 800,
                        letterSpacing: '0.02em',
                        width: '100%',
                    },

                    [mobileOnly]: {
                        marginBottom: 0,
                        position: 'relative',

                        h3: {
                            fontSize: 16,
                        },

                        div: {
                            position: 'absolute',
                            right: 0,
                            top: '-30px',
                        }
                    },
                },
                '.total': {
                    marginRight: 10,
                    fontStyle: 'normal',
                    fontWeight: 600,
                    fontSize: 14,
                    lineHeight: '135%',
                    color: colors.GREEN_BRIGHT,
                },
                /*
                '.subtotal': {
                    fontStyle: 'normal',
                    fontWeight: 600,
                    fontSize: 14,
                    lineHeight: '135%',
                    textDecorationLine: 'line-through',
                    color: colors.NAVY,
                },
                */
                '.no-discount-total': {
                    marginRight: 10,
                    fontStyle: 'normal',
                    fontWeight: 600,
                    fontSize: 14,
                    lineHeight: '135%',
                    color: colors.NAVY,
                },
                '.lines-wrapper': {
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'nowrap',
                    justifyContent: 'space-between',

                    [mobileOnly]: {
                        flexDirection: 'column',
                    },

                    '.lines': {
                        marginBottom: 14,
                        lineHeight: '100% !important',

                        '.toggle': {
                            background: 'none',
                            border: 'none',
                            fontStyle: 'normal',
                            fontWeight: 'bold',
                            fontSize: 13,
                            lineHeight: '135%',
                            padding: 0,
                            marginRight: 7,
                            color: colors.BLUE,
                        },
                        img: {
                            marginLeft: 7,
                        },

                        [mobileOnly]: {
                            margin: '0 0 15px 0',
                        },

                        '.content': {
                            marginTop: 5,
                            marginBottom: 15,

                            '.sum-row': {
                                letterSpacing: '0.01em',
                                display: 'flex',
                                justifyContent: 'flex-start',
                                [mobileOnly]: {
                                    justifyContent: 'space-between',
                                },
                                '.caption': {
                                    fontSize: 13,
                                    marginRight: 10,
                                    color: colors.NAVY,
                                },
                                '.total': {
                                    marginTop: 'auto',
                                    marginBottom: 'auto',
                                    marginLeft: 5,
                                    fontSize: 13,
                                    color: colors.NAVY,

                                    '&.with-discount': {
                                        'span:first-child': {
                                            color: colors.NAVY,
                                            textDecorationLine: 'line-through',
                                            marginRight: 6,
                                        },
                                        'span:last-child': {
                                            color: colors.GREEN_BRIGHT,
                                        }
                                    },
                                },
                            },
                        },
                    },
                },

                '.subscribe-delivery': {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    zIndex: 3,
                    [mobileOnly]: {
                        width: '100%',
                    },
                    '.delivery': {
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        flexDirection: 'row',
                        [tabletLandscapeUp]: {
                            justifyContent: 'flex-start',
                        },

                        label: {
                            fontStyle: 'normal',
                            fontWeight: 'normal',
                            fontSize: 14,
                            lineHeight: '145%',
                            marginRight: 11,
                        },

                        '.select-dropdown': {
                            '.select__control, .select__control--is-focused': {
                                border: 'none !important',
                                boxShadow: 'none !important',
                                padding: 0,
                                marginTop: 5,
                            },

                            '.select__single-value': {
                                fontStyle: 'normal',
                                fontWeight: 'bold',
                                fontSize: 14,
                                lineHeight: '145%',
                            },
                            '.select__menu': {
                                fontStyle: 'normal',
                                fontWeight: 'bold',
                                fontSize: 14,
                                lineHeight: '145%',
                                color: colors.BLUE,
                                textAlign: 'left',
                            },
                            '.select__value-container': {
                                margin: 0,
                                padding: 0,

                                svg: {
                                    color: colors.BLUE
                                }
                            },

                            '.select__indicator': {
                                svg: {
                                    color: colors.BLUE
                                }
                            }
                        }
                    },

                    '.subscribe': {
                        display: 'flex',
                        marginBottom: 10,
                        [mobileOnly]: {
                            marginBottom: 13,
                        },

                        '.tooltip-img': {
                            marginLeft: 8,
                            cursor: 'pointer',
                            marginTop: 'auto',
                            marginBottom: 'auto',
                            width: 20,
                            height: 20,

                            [mobileOnly]: {
                                display: 'none'
                            },
                        },
                        span: {
                            fontStyle: 'normal',
                            fontWeight: 'normal',
                            fontSize: 14,
                            letterSpacing: '0.01em',
                            color: colors.NAVY,
                            [mobileOnly]: {
                                fontSize: 12,
                            },
                        }
                    },
                },
                '.cart-quantity': {
                    alignSelf: 'baseline',

                    '.default': {
                        width: 120,
                    },
                    [tabletLandscapeUp]: {
                        marginLeft: 10,
                    },
                    [desktopUp]: {
                        '.default': {
                            width: 160,
                        }
                    },
                },
            },

            '.remove-box, .edit-box': {
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                flexDirection: 'row',
                alignContent: 'center',
                paddingLeft: 50,
                cursor: 'pointer',
                '&.desktop': {
                    display: 'none',
                    [tabletLandscapeUp]: {
                        paddingLeft: 30,
                        display: 'block',
                        marginBottom: 20,
                    },
                    [desktopUp]: {
                        paddingLeft: 50,
                    }
                },
                '&.mobile': {
                    display: 'block',
                    marginRight: 10,
                    alignSelf: 'baseline',
                    [tabletLandscapeUp]: {
                        display: 'none',
                    }
                },
            },
            '.edit-box': {
                marginLeft: '-5px',
                position: 'absolute',
                marginTop: 10,

                [tabletLandscapeUp]: {
                    display: 'none',
                    position: 'relative'
                }
            },
            '.cart-total': {
                display: 'flex',
                flexWrap: 'wrap',
                flexDirection: 'row',
                alignItems: 'center',
                alignContent: 'center',
                justifyContent: 'flex-start',
                marginRight: 5,

                span: {
                    marginTop: 10,
                }
            },
        },

        hr: {
            marginTop: 12,
            marginBottom: 12,
            color: colors.BLUE_LIGHT,
            width: '100%'
        },

        [mobileOnly]: {
            margin: 0,
            marginTop: 28,
            marginBottom: 19,
        },
    }),

    summaryWrap: css({
        padding: '25px !important',
        width: '100%',

        '.order-type': {
            paddingTop: 12,
            paddingLeft: 8,

            input: {
                zIndex: 1,
                cursor: 'pointer'
            },
            label: {
                lineHeight: 1.4,
                paddingBottom: 15,
                fontSize: 14,
                display: 'block',
            }
        },

        '.summary-table': {
            borderRadius: 0,
            margin: '-25px -25px 40px -25px',
            padding: '35px 30px !important',
            background: colors.WHITE,

            '.sum-row-hr': {
                backgroundColor: `${colors.BLUE_LIGHT} !important`,
            },
            '.caption': {
                color: `${colors.NAVY} !important`,
            },
            '.checkout-title': {
                textAlign: 'center',
                marginBottom: 25,
                fontStyle: 'normal',
                fontWeight: 'bold',
                fontSize: 15,
                letterSpacing: '0.2em',
                textTransform: 'uppercase',
            },
        },
        [tabletLandscapeUp]: {
            '.summary-table': {
                borderRadius: 20,
                margin: '0',
                border: 'solid 1px #cfd5e5',
            },
        }
    }),
};
